// extracted by css-extract-rspack-plugin
export default {"file_icon":"KBiTICIdUIRC1hJT","tableWrapper":"UuiVuv7q9ALMZCZ_","modal":"R06GqWgqalkQRVJD"};